import { gql } from '@apollo/client';

export default class ChecksSubscription {
    static UPDATED_PAYROLL_PRINTING_STATUS = gql`
        subscription updatedPayrollPrintingStatus($printingRequestId: ID!) {
            updatedPayrollPrintingStatus(printingRequestId: $printingRequestId)
        }
    `;

    static ADJUSTMENTS_UPDATED = gql`
        subscription adjustmentsUpdated($employeeId: Int!, $payPeriod: String!) {
            adjustmentsUpdated(employeeId: $employeeId, payPeriod: $payPeriod)
        }
    `;
}
